export default __webpack_public_path__ + "static/banner_image-fe2d112fd9bfaddb90ade47473a2dd26.png";